// import Swiper JS

import 'swiper/swiper-bundle.css';
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Keyboard } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Keyboard]);

export const useSwiper = (config = {}) => new Swiper(
  '.swiper-container',
  {
    freeMode: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
    slidesPerView: 'auto',
    spaceBetween: 20,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    autoplay: {
      delay: 5000,
    },
    ...config,
  }
)